import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./QueryModals.module.css";
import StatusBadge from "./StatusBadge";
import QueryDetailsSummary from "./QueryDetailsSummary";
import { formatDateTime } from "./formatDateTime";

const QueryViewModal = ({ data }: { data: any }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={handleShow}
        className={styles.iconBtn}
        title="View query details"
      >
        <i className="uil uil-eye"></i>
      </Button>

      <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title as="h6" className="mb-0">
            Query Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <QueryDetailsSummary data={data} />

          {data?.remarks?.length > 0 && (
            <div className="mt-3">
              <div className={styles.sectionLabel}>Activity & Remarks</div>
              <div className={styles.timeline}>
                {[...data.remarks].reverse().map((remark: any, idx: number) => (
                  <div className={styles.timelineItem} key={remark?._id || idx}>
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                      <StatusBadge status={remark?.status} />
                      <span className="text-muted small">
                        {formatDateTime(remark?.updatedAt)}
                      </span>
                    </div>
                    {remark?.remarks && (
                      <p className="mb-0 mt-1 text-muted">{remark.remarks}</p>
                    )}
                    {remark?.queryStatusUpdatedBy?.name && (
                      <div className="mt-1 small text-muted">
                        <i className="uil uil-user-check me-1"></i>
                        Updated by{" "}
                        <span className="fw-semibold text-body">
                          {remark.queryStatusUpdatedBy.name}
                        </span>
                        {remark.queryStatusUpdatedBy.mob && (
                          <>
                            {" ("}
                            <a href={`tel:${remark.queryStatusUpdatedBy.mob}`}>
                              {remark.queryStatusUpdatedBy.mob}
                            </a>
                            {")"}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default QueryViewModal;
